//Install
import React, { Component } from 'react';
//Install
import { Swiper, SwiperSlide } from "swiper/react";
//Install
import { Navigation, Pagination, Autoplay } from "swiper/modules";
//Install
import J6864C from "../../../Media/Image/049.jpg";
//Install
import F8938K from "../../../Media/Image/040.jpg";
//Install
import N556JV from "../../../Media/Image/044.jpg";
//Install
import E872IZ from "../../../Media/Image/045.jpg";
//Install
import U670D7 from "../../../Media/Image/046.jpg";
//Install
import F99X35 from "../../../Media/Image/050.jpg";

//Element
class F447P0 extends Component {
    //Element
    render() {
        //Element
        const D3154C = {
            //Element
            spaceBetween: "0",
            //Element
            slidesPerView: "1",
            //Element
            autoplay: {
                //Element
                delay: 2500
            },
            //Element
            loop: true,
            //Element
            freeMode: true,
            //Element
            breakpoints: {
                //Element
                320: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                360: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                480: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                504: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                600: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                768: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                1024: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                1280: {
                    //Element
                    slidesPerView: 1
                }
            },
            //Element
            modules: [Navigation, Pagination, Autoplay]
        }
        //Element
        const Content = React.createElement(Swiper, { className: "S6pt64 C96Q4r pEO064 a527eB t9192b", ...D3154C },
            //Element
            React.createElement(SwiperSlide, {},
                //Element
                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i7w56k", style: { backgroundImage: `url(${J6864C})` } })
            ),
            //Element
            React.createElement(SwiperSlide, {},
                //Element
                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i7w56k", style: { backgroundImage: `url(${F8938K})` } })
            ),
            //Element
            React.createElement(SwiperSlide, {},
                //Element
                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i7w56k", style: { backgroundImage: `url(${N556JV})` } })
            ),
            //Element
            React.createElement(SwiperSlide, {},
                //Element
                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i7w56k", style: { backgroundImage: `url(${E872IZ})` } })
            ),
            //Element
            React.createElement(SwiperSlide, {},
                //Element
                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB i7w56k", style: { backgroundImage: `url(${U670D7})` } })
            ),
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default F447P0;